module.exports = __webpack_public_path__ + "static/media/fastFabric.43960b0d.jpg";